export default {"src":"/_next/static/media/github.0625e4a8.svg","height":16,"width":16};